import { gql } from "@apollo/client";

export default gql`
  query getAskAIChatSessionHistoryQuery($after: String) {
    chatSessions(first: 20, after: $after, orderBy: "-id") {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          created
          updated
          title
          pinnedAt
          assessment {
            id
            target {
              id
              name
            }
          }
          assessmentQuestion {
            id
            title
          }
          meeting {
            id
            title
          }
          messages(first: 1, role: "user") {
            edges {
              node {
                id
                content
                imageUrls
                role
              }
            }
          }
        }
      }
    }
  }
`;
